import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    paymentRequests: [],
    selectedPage: null
};

const paymentRequestSlice = createSlice({
    name: "paymentRequest",
    initialState,
    reducers: {
        setPaymentRequest: (state, action) => {
            state.paymentRequests = action.payload;
        },
        setSelectPage: (state, action) => {
            state.selectedPage = action.payload;
        },
    },
});

export const {
    setPaymentRequest, setSelectPage
} = paymentRequestSlice.actions;

export default paymentRequestSlice.reducer;
